//
import { ProductModel } from '@/models'

/**
 * 
 */
const fetchAll = async function () {

    //
    try {

        //
        const product = await ProductModel.params({ get_all_results : true }).get()

        //
        return product.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default fetchAll
